<template lang="pug">
    li
        .dropdown(@mouseover="openModal", @mouseleave="closeModal")
            a.dropdown__toggle.dropdown-right-side-link
                span {{ lenguage == 'EN' ? 'EN' : 'ES' }}
                    i.fas.fa-chevron-down
            transition(name="fade")
                .dropdown__content.dropdown-products(v-bind:class="{ 'open': active }")
                    ul.list-style-none.is-dropdown
                        li
                            router-link.is-dropped(to="/en")    EN
                                img(:src="en")
                        li
                            router-link.is-dropped(to="/es")    ES
                                img(:src="es")
</template>

<script>
import en from '@img/en.png'
import es from '@img/es.png'
export default {
    props: ['lenguage'],
    data: function(){
        return {
            active: false,
            en: en,
            es: es
        }
    },
    methods: {
        openModal: function(){
            this.$data.active = true
        },
        closeModal: function(){
            this.$data.active = false
        }
    }
}
</script>


<style lang="scss" scoped>
.dropdown-products{
    width: 110px;
    img{
        width: 30px;
        float: right;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/atoms/PmNavLenguage.vue